module.exports = __webpack_public_path__ + "69c1d1e9b724562eba17fc398d9c761b.png";